import Table from "components/DataTable/Table";
import { setNotification } from "features/Notification/notificationSlice";
import { portalLoginUrl } from "pages/Portal/portalApi";
import ContactPortalButton from "pages/Sales/Customers/CutomerDetails/CustomerContact/ContactPortalButton";
import { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import authHeader from "services/auth-header";
import API from "services/axios";

// Settings -> Portal Users (user, 2026-11-05): every customer contact with a
// portal login. Logins are created on the customer's Contacts tab ("Create
// Portal"); here they can be reset or disabled. Replaces the old list of
// users with role "customer".
function PortalUsers() {
  const dispatch = useDispatch();
  const user = useSelector((state) => state.user?.userInfo);
  const [rows, setRows] = useState(null);
  const loginUrl = portalLoginUrl(user?.companyId);

  const load = useCallback(async () => {
    try {
      const { data } = await API.get("/customer-portal/users", {
        headers: authHeader(),
      });
      setRows(
        (data?.data || []).map((r) => ({ ...r, portalEnabled: true })),
      );
    } catch (err) {
      setRows([]);
      dispatch(
        setNotification({
          message: err?.response?.data?.message || err.message,
          type: "error",
        }),
      );
    }
  }, [dispatch]);

  useEffect(() => {
    load();
  }, [load]);

  const copyLink = () => {
    navigator.clipboard.writeText(loginUrl);
    dispatch(setNotification({ message: "Link copied", type: "success" }));
  };

  const buttons = () => (
    <div className="d-flex align-items-center gap-1 ms-2 small">
      <span className="text-muted">Portal link:</span>
      <code>{loginUrl}</code>
      <button type="button" className="btn btn-sm px-1" onClick={copyLink} title="Copy link">
        <i className="mdi mdi-content-copy"></i>
      </button>
    </div>
  );

  const fmt = (d) => (d ? new Date(d).toLocaleString() : "Never");

  const table_head = ["Customer", "Contact", "Email", "Last login", "Action"];
  const table_body = (item) => (
    <tr key={item.id}>
      <td className="align-middle">
        {item.customerId ? (
          <Link to={`/customer/details/${item.customerId}`}>
            {item.customerName || "-"}
          </Link>
        ) : (
          item.customerName || "-"
        )}
      </td>
      <td className="align-middle">
        {[item.firstName, item.lastName].filter(Boolean).join(" ")}
      </td>
      <td className="align-middle">{item.email}</td>
      <td className="align-middle">{fmt(item.portalLastLogin)}</td>
      <td className="align-middle text-end">
        <ContactPortalButton contact={item} onChanged={load} />
      </td>
    </tr>
  );

  return (
    <div className="row">
      <h3>Customer Portal Users</h3>
      <p className="text-muted">
        To give a customer a login, open the customer, go to Contacts and click
        "Create Portal" on the contact.
      </p>
      <div className="col-12">
        <Table
          btn1={buttons}
          table_body={table_body}
          table_data={rows}
          table_head={table_head}
        />
      </div>
    </div>
  );
}

export default PortalUsers;
